import { jsx as _jsx } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
/**
 * Svgs are a type of **atom** that represent a `<svg>` element.
 */
const Svg = ({ children, className, size, viewBox, ...rest }) => {
    return (_jsx("svg", { className: buildClassName({
            'h-4 w-4': size === '16px',
            'h-6 w-6': size === '24px',
            'h-8 w-8': size === '32px',
        }, className), viewBox: viewBox, xmlns: "http://www.w3.org/2000/svg", ...rest, children: children }));
};
export default Svg;
//# sourceMappingURL=Svg.js.map